import './ChatInput.css'
import { ArrowUp, Mic, Paperclip } from "lucide-react";

const ChatInput = ({
  input,
  setInput,
  handleQuery,
  isFetching,
  placeholder = "What can I do for you...",
}) => {
  return (
    <div className="chat-input-section">
      <div className="chat-input-container">
        <input
          className="chat-input"
          placeholder={placeholder}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && !isFetching && handleQuery()}
        />
        <div className="chat-input-buttons">
          <div
            style={{
              display: "flex",
              flex: 1,
              width: "412px",
              height: "40px",
              gap: "4px",
            }}
          >
            <Paperclip className="attach-logo" />
          </div>
          <div
            style={{
              display: "flex",
              width: "84px",
              height: "40px",
              gap: "4px",
            }}
          >
            <Mic className="mic-logo" />
            <button
              onClick={handleQuery}
              className="send-button"
              disabled={isFetching}
            >
              <ArrowUp className="send-logo"/>
            </button>
          </div>
        </div>
      </div>
      <span className="input-below-text">
        This AI assistant provides guidance based on available data. Verify
        critical information before proceeding.
      </span>
    </div>
  );
};

export default ChatInput;
